import { Plus } from "lucide-react";
import BlueButton from "./BlueButton";

export default function AddButton({
  onClick,
  label = "Add",
  size = 14,
  disabled = false,
  className = "",
}) {
  return (
    <BlueButton
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center gap-2 py-1 px-2 ${className}`}
    >
      <Plus size={size} />

      {/* Hide label on mobile */}
      <span className="hidden sm:inline">
        {label}
      </span>
    </BlueButton>
  );
}